import React from 'react';
import styles from './UIGameEndHeader.module.scss';
import { AdBox } from './AdBox/index.ts';
import { EndGameHeaderInfo } from './EndGameHeaderInfo/index.ts';
import { FADE_IN_ANIMATION_DELAYS } from '../constants.ts';
import { FadeInContainer } from '../../../common/FadeInContainer/index.ts';
import { MapReplayButton } from './ActionButtons/MapReplayButton.tsx';
import { ShareButton } from './ActionButtons/ShareButton.tsx';
import { GameResultsControlsShareButton } from '../../UIGameGameResultsControls/GameResultsControlsShareButton.tsx';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import clsx from 'clsx';
export function UIGameEndHeader({ disableAnimation, onClickShareGameResults }) {
    const gameOrientation = useGameStore((state)=>state.gameClientConfig.gameOrientation);
    const shouldHideStoreFeatures = useGameStore((state)=>state.gameClientConfig.shouldHideStoreFeatures);
    const isPortrait = gameOrientation == 'portrait';
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.header
    }, /*#__PURE__*/ React.createElement(FadeInContainer, {
        animationDelayMs: FADE_IN_ANIMATION_DELAYS.ads,
        animationDurationMs: FADE_IN_ANIMATION_DELAYS.transitionDuration,
        disableAnimation: disableAnimation,
        className: styles.leftFadeInContainer,
        id: "endgame-item-box"
    }, /*#__PURE__*/ React.createElement(AdBox, {
        className: styles.adBox
    }), /*#__PURE__*/ React.createElement(MapReplayButton, {
        text: "strings:game.endGame.cornerButton.map",
        className: clsx(styles.leftMapReplayButtonContainer, {
            [styles.showInPortrait]: isPortrait
        })
    })), /*#__PURE__*/ React.createElement(EndGameHeaderInfo, {
        disableAnimation: disableAnimation
    }), /*#__PURE__*/ React.createElement(FadeInContainer, {
        animationDelayMs: FADE_IN_ANIMATION_DELAYS.topLeftButtons,
        animationDurationMs: FADE_IN_ANIMATION_DELAYS.transitionDuration,
        disableAnimation: disableAnimation
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.rightActionButtonsContainer, {
            [styles.hideInPortrait]: isPortrait
        })
    }, /*#__PURE__*/ React.createElement(MapReplayButton, {
        text: "strings:game.endGame.cornerButton.mapWithReplay"
    }), /*#__PURE__*/ React.createElement(ShareButton, null)), !shouldHideStoreFeatures && /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.rightShareButtonContainer, {
            [styles.showInPortrait]: isPortrait
        })
    }, /*#__PURE__*/ React.createElement(GameResultsControlsShareButton, {
        onShare: onClickShareGameResults,
        spinnerClassName: styles.spinner
    }))));
}
